import { IBuyBarProductVariant } from 'shared/types/BuyBarProductVariant';
import { ISize } from 'shared/types/Size';

/**
 * [getFirstLowestPriceVariants] returns the first lowest price variant for
 * each size that is within the shoeConditions array and boxConditions array
 * @param productVariants
 * @param shoeConditions {[]} an array of SHOE_CONDITIONS to filter by
 * @param boxConditions {[]} an array of BOX_CONDITIONS to filter by
 * @param getInstantShipLowestPrice {boolean} true if we are looking for lowest `instantShipLowestPriceCents`
 * @returns {*}
 */
export const getFirstLowestPriceVariants = (
  productVariants: IBuyBarProductVariant[],
  shoeConditions = [],
  boxConditions = [],
  getInstantShipLowestPrice = false,
  productTemplateSizeOptionsMap: Map<number, ISize> = null,
) => {
  const map = new Map<number, IBuyBarProductVariant>();
  if (productVariants)
    for (const variant of productVariants) {
      if (
        productTemplateSizeOptionsMap !== null &&
        !productTemplateSizeOptionsMap?.get(variant?.sizeOption?.value)
      )
        continue;
      if (variant.stockStatus === 'not_in_stock') continue;
      if (shoeConditions.length > 0 && !shoeConditions.includes(variant.shoeCondition)) continue;
      if (boxConditions.length > 0 && !boxConditions.includes(variant.boxCondition)) continue;

      const price = getInstantShipLowestPrice ? 'instantShipLowestPriceCents' : 'lowestPriceCents';
      const currentVariantLowestPrice = variant[price]?.amount;
      if (!currentVariantLowestPrice) continue;

      if (map.has(variant?.sizeOption?.value)) {
        const previousLowestPrice = map.get(variant?.sizeOption?.value)[price]?.amount;

        if (currentVariantLowestPrice < previousLowestPrice) {
          map.set(variant?.sizeOption?.value, variant);
        }
      } else {
        map.set(variant?.sizeOption?.value, variant);
      }
    }

  return [...map.values()];
};
